<!-- splash screen -->
<div #splashScreen class="splash-screen">
	<h3>CONTRATO</h3>
	<!-- <img src="../../../../../assets/images/Contrato-Logo_Option-1.gif" alt="Logo" /> -->
	<mat-spinner diameter="40"></mat-spinner>
</div>
